<template>
  <base-form :can-back="isEnableBack">
    <slot />
    <template #submit-button v-if="canEdit">
      <edit-button class="px-5" />
    </template>
    <template #expansion-buttons-left>
      <slot name="expansion-buttons-left" />
    </template>
    <template #expansion-buttons-center>
      <slot name="expansion-buttons-center" />
    </template>
    <template #expansion-buttons-right>
      <slot name="expansion-buttons-right" />
    </template>
    <template #talk>
      <slot name="talk" />
    </template>
  </base-form>
</template>

<script>
import BaseForm from '@/views/templates/forms/BaseForm'
import EditButton from '@/views/molecules/buttons/EditButton'

export default {
  name: "ViewerForm",
  components: {
    BaseForm,
    EditButton,
  },
  props: {
    canEdit: {
      type: Boolean,
      default: false,
    },
    canBack: {
      type: Boolean,
      default: false,
    },
    requireBack: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isEnableBack() {
      return this.requireBack ? this.requireBack : this.canBack && !this.$store.state.account.is_guest;
    },
  },
}
</script>
